import { useState, useEffect } from 'react';
import axios from 'axios';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SERIES = [
  { key: 'identificazioni', label: 'Clienti identificati', color: '#283880' },
  { key: 'consegne', label: 'Documenti consegnati', color: '#C9A227' },
  { key: 'richieste', label: 'Richieste di accesso', color: '#94A3B8' },
];
const monthLabel = (m) => new Date(`${m}-01T12:00:00`).toLocaleDateString('it-IT', { month: 'short', year: '2-digit' });

export const ChatStatsChart = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/chat-stats`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => setData(r.data.map((d) => ({ ...d, label: monthLabel(d.month) }))))
      .catch(() => setData([]));
  }, []);

  const totals = SERIES.map((s) => ({ ...s, total: (data || []).reduce((a, d) => a + d[s.key], 0) }));
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm mb-8" data-testid="chat-stats-chart">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <h3 className="font-semibold text-[#283880]">Assistente virtuale – ultimi 12 mesi</h3>
          <p className="text-xs text-slate-500">Accessi, consegne di documenti e richieste di accesso arrivate dalla chat</p>
        </div>
        <div className="flex gap-6">
          {totals.map((s) => (
            <div key={s.key} data-testid={`chat-stats-total-${s.key}`}>
              <p className="text-2xl font-bold" style={{ color: s.color }}>{s.total}</p>
              <p className="text-[11px] text-slate-500">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="h-72">
        {data && (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
              <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#64748B' }} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#64748B' }} axisLine={false} tickLine={false} />
              <Tooltip cursor={{ fill: '#F1F5F9' }} contentStyle={{ borderRadius: 8, border: '1px solid #E2E8F0', fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              {SERIES.map((s) => <Bar key={s.key} dataKey={s.key} name={s.label} fill={s.color} radius={[3, 3, 0, 0]} />)}
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};
